// // import React, { useState, useEffect, useCallback } from 'react';
// // import { RiCollapseDiagonalLine } from "react-icons/ri";
// // import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
// // import { FaFilter } from "react-icons/fa";
// // import { TbReload, TbArrowsSort } from "react-icons/tb";
// // import { FaDownload, FaEye } from "react-icons/fa6";

// // const API_URL = process.env.REACT_APP_API_BASE|| '';

// // // ── Status Badge ─────────────────────────────────────────────────────────────
// // function StatusBadge({ status }) {
// //     const s = (status || '').toLowerCase();
// //     const map = {
// //         running:   'bg-yellow-100 text-yellow-700 border-yellow-200',
// //         completed: 'bg-green-100 text-green-700 border-green-200',
// //         failed:    'bg-red-100 text-red-600 border-red-200',
// //         pending:   'bg-gray-100 text-gray-600 border-gray-200',
// //         scheduled: 'bg-blue-100 text-blue-700 border-blue-200',
// //     };
// //     const cls = map[s] || 'bg-gray-100 text-gray-600 border-gray-200';
// //     return (
// //         <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border ${cls} capitalize`}>
// //             {status || '-'}
// //         </span>
// //     );
// // }

// // // ── Campaign Detail Modal ─────────────────────────────────────────────────────
// // function CampaignDetailModal({ campaignId, campaignName, onClose }) {
// //     const [messages, setMessages] = useState([]);
// //     const [loading, setLoading]   = useState(true);
// //     const [search, setSearch]     = useState('');

// //     useEffect(() => {
// //         if (!campaignId) return;
// //         (async () => {
// //             setLoading(true);
// //             try {
// //                 const res  = await fetch(`${API_URL}/auth/campaign/${campaignId}`, { credentials: 'include' });
// //                 const json = await res.json();
// //                 setMessages(json.data || []);
// //             } catch (e) { console.error(e); }
// //             finally { setLoading(false); }
// //         })();
// //     }, [campaignId]);

// //     const filtered = messages.filter(m =>
// //         !search || (m.phone_number || '').includes(search)
// //     );

// //     const statusCount = messages.reduce((acc, m) => {
// //         const s = m.status || 'pending';
// //         acc[s] = (acc[s] || 0) + 1;
// //         return acc;
// //     }, {});

// //     return (
// //         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
// //             <div className="bg-white dark:bg-[#1a1f24] rounded-xl shadow-2xl w-[90vw] max-w-3xl max-h-[85vh] flex flex-col">
// //                 {/* Header */}
// //                 <div className="flex items-center justify-between px-5 py-4 border-b border-[#dee2e6] dark:border-[#2a2f35]">
// //                     <div>
// //                         <h2 className="text-[14px] font-bold text-[#000] dark:text-white">{campaignName}</h2>
// //                         <p className="text-[11px] text-gray-400">Campaign Messages — {messages.length} total</p>
// //                     </div>
// //                     <button
// //                         onClick={onClose}
// //                         className="text-gray-400 hover:text-red-500 text-[18px] font-bold transition-colors"
// //                     >✕</button>
// //                 </div>

// //                 {/* Stats Strip */}
// //                 {!loading && (
// //                     <div className="flex gap-3 px-5 py-3 bg-[#f6f9fc] dark:bg-[#121519] border-b border-[#dee2e6] dark:border-[#2a2f35] flex-wrap">
// //                         {Object.entries(statusCount).map(([s, c]) => (
// //                             <div key={s} className="flex items-center gap-1">
// //                                 <StatusBadge status={s} />
// //                                 <span className="text-[11px] font-bold text-gray-600 dark:text-gray-300">{c}</span>
// //                             </div>
// //                         ))}
// //                     </div>
// //                 )}

// //                 {/* Search */}
// //                 <div className="px-5 py-2 border-b border-[#dee2e6] dark:border-[#2a2f35]">
// //                     <input
// //                         value={search}
// //                         onChange={e => setSearch(e.target.value)}
// //                         placeholder="Search by phone number..."
// //                         className="w-full sm:w-64 text-[12px] border border-[#d4cfcf] rounded-md px-2 py-1.5 outline-none dark:bg-[#121519] dark:text-white"
// //                     />
// //                 </div>

// //                 {/* Table */}
// //                 <div className="overflow-auto flex-1">
// //                     {loading ? (
// //                         <div className="text-center py-10 text-[12px] text-gray-400">Loading messages...</div>
// //                     ) : (
// //                         <table className="w-full border-collapse">
// //                             <thead className="sticky top-0 bg-[#f6f9fc] dark:bg-[#121519]">
// //                                 <tr>
// //                                     {['#', 'Phone Number', 'Variables', 'Status', 'Sent At'].map(col => (
// //                                         <th key={col} className="p-2 text-left text-[11px] font-semibold text-[#576071] dark:text-white border-b border-[#dee2e6]">
// //                                             {col}
// //                                         </th>
// //                                     ))}
// //                                 </tr>
// //                             </thead>
// //                             <tbody>
// //                                 {filtered.length === 0 ? (
// //                                     <tr><td colSpan={5} className="text-center py-6 text-[11px] text-gray-400">No messages found</td></tr>
// //                                 ) : filtered.map((m, i) => {
// //                                     let vars = '-';
// //                                     try { vars = JSON.parse(m.variables || '[]').join(', ') || '-'; } catch {}
// //                                     return (
// //                                         <tr key={m.id || i} className="odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#e8f0fa] dark:hover:bg-[#2a2f35] transition-colors">
// //                                             <td className="p-2 text-[11px] border-b border-[#dee2e6] dark:text-white text-gray-400">{i + 1}</td>
// //                                             <td className="p-2 text-[11px] border-b border-[#dee2e6] dark:text-white font-mono">{m.phone_number || '-'}</td>
// //                                             <td className="p-2 text-[11px] border-b border-[#dee2e6] dark:text-white text-gray-500 max-w-[160px] truncate">{vars}</td>
// //                                             <td className="p-2 text-[11px] border-b border-[#dee2e6]"><StatusBadge status={m.status} /></td>
// //                                             <td className="p-2 text-[11px] border-b border-[#dee2e6] dark:text-white text-gray-400">
// //                                                 {m.sent_at ? new Date(m.sent_at).toLocaleString() : (m.created_at ? new Date(m.created_at).toLocaleString() : '-')}
// //                                             </td>
// //                                         </tr>
// //                                     );
// //                                 })}
// //                             </tbody>
// //                         </table>
// //                     )}
// //                 </div>

// //                 {/* Footer */}
// //                 <div className="px-5 py-3 border-t border-[#dee2e6] dark:border-[#2a2f35] flex justify-end">
// //                     <button
// //                         onClick={onClose}
// //                         className="px-4 py-1.5 text-[12px] font-semibold bg-[#37715d] text-white rounded-lg hover:bg-[#2d5e4e] transition-colors"
// //                     >Close</button>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // }

// // // ── Main CampaignReport ───────────────────────────────────────────────────────
// // function CampaignReport() {
// //     const [showfilter, setshowfilter]   = useState(false);
// //     const [CampaignName, setCampaignName] = useState('');
// //     const [TemplateType, setTemplateType] = useState('');
// //     const [StatusFilter, setStatusFilter] = useState('');

// //     const [allData, setAllData]   = useState([]);
// //     const [filtered, setFiltered] = useState([]);
// //     const [loading, setLoading]   = useState(false);
// //     const [error, setError]       = useState('');

// //     // Detail modal
// //     const [modalCampaign, setModalCampaign] = useState(null); // { id, name }

// //     // Pagination
// //     const [currentPage, setCurrentPage]  = useState(1);
// //     const usersperpage = 10;
// //     const indexoflastuser  = currentPage * usersperpage;
// //     const indexoffirstuser = indexoflastuser - usersperpage;
// //     const pageData   = filtered.slice(indexoffirstuser, indexoflastuser);
// //     const totalpages = Math.ceil(filtered.length / usersperpage);

// //     // ── Fetch ────────────────────────────────────────────────────────────────
// //     const fetchData = useCallback(async () => {
// //         setLoading(true);
// //         setError('');
// //         try {
// //             const res  = await fetch(`${API_URL}/auth/campaign/report`, { credentials: 'include' });
// //             const json = await res.json();
// //             if (!json.success) throw new Error('Failed to load');
// //             setAllData(json.data || []);
// //             setFiltered(json.data || []);
// //         } catch (e) {
// //             setError('Failed to load campaign data.');
// //             console.error(e);
// //         } finally {
// //             setLoading(false);
// //         }
// //     }, []);

// //     useEffect(() => { fetchData(); }, [fetchData]);

// //     // ── Filter ───────────────────────────────────────────────────────────────
// //     const applyFilter = () => {
// //         let d = [...allData];
// //         if (CampaignName) d = d.filter(r => (r.campaign_name || '').toLowerCase().includes(CampaignName.toLowerCase()));
// //         if (TemplateType) d = d.filter(r => r.template_type === TemplateType);
// //         if (StatusFilter) d = d.filter(r => (r.status || '').toLowerCase() === StatusFilter.toLowerCase());
// //         setFiltered(d);
// //         setCurrentPage(1);
// //     };

// //     const clearFilter = () => {
// //         setCampaignName(''); setTemplateType(''); setStatusFilter('');
// //         setFiltered(allData); setCurrentPage(1);
// //     };

// //     // ── CSV Download ─────────────────────────────────────────────────────────
// //     const handleDownload = () => {
// //         const headers = ['ID', 'Campaign Name', 'Template Name', 'Template Type', 'Interface', 'Total Count', 'Status', 'Created At'];
// //         const rows = filtered.map(r => [
// //             r.id, r.campaign_name, r.template_name, r.template_type,
// //             r.interface, r.total_count, r.status,
// //             r.created_at ? new Date(r.created_at).toLocaleString() : ''
// //         ]);
// //         const csv = [headers, ...rows].map(row => row.map(v => `"${v ?? ''}"`).join(',')).join('\n');
// //         const blob = new Blob([csv], { type: 'text/csv' });
// //         const url  = URL.createObjectURL(blob);
// //         const a    = document.createElement('a');
// //         a.href     = url; a.download = 'campaign_report.csv'; a.click();
// //         URL.revokeObjectURL(url);
// //     };

// //     const columns = ['#', 'Campaign Name', 'Template Name', 'Template Type', 'Interface', 'Total', 'Status', 'Created At', 'Action'];

// //     return (
// //         <>
// //             {/* Modal */}
// //             {modalCampaign && (
// //                 <CampaignDetailModal
// //                     campaignId={modalCampaign.id}
// //                     campaignName={modalCampaign.name}
// //                     onClose={() => setModalCampaign(null)}
// //                 />
// //             )}

// //             {/* Top Actions */}
// //             <div className='w-full flex items-center justify-between mb-2'>
// //                 <p className='text-[12px] text-gray-500 dark:text-gray-400'>
// //                     Total: <span className='font-bold text-[#37715d]'>{allData.length}</span> campaigns
// //                 </p>
// //                 <div className='flex gap-2'>
// //                     <button
// //                         onClick={fetchData}
// //                         className='flex items-center justify-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-1 hover:bg-[#37715d] hover:text-white transition-colors'
// //                     >
// //                         <TbReload className='text-[13px]' />
// //                         <span className='text-[12px] font-bold'>Refresh</span>
// //                     </button>
// //                     <button
// //                         onClick={handleDownload}
// //                         className='flex items-center justify-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-1 hover:bg-[#3f7fca] hover:text-white transition-colors'
// //                     >
// //                         <FaDownload className='text-[12px]' />
// //                         <span className='text-[12px] font-bold'>Download</span>
// //                     </button>
// //                 </div>
// //             </div>

// //             {/* Filter Bar */}
// //             <div
// //                 onClick={() => setshowfilter(!showfilter)}
// //                 className='w-full flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] cursor-pointer'
// //             >
// //                 <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-white'>
// //                     <RiCollapseDiagonalLine /> Filter Records
// //                 </div>
// //                 <div className='flex items-center text-[#576071] dark:text-white'>
// //                     {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
// //                 </div>
// //             </div>

// //             {showfilter && (
// //                 <div className='bg-[#edf1f5] py-2 px-4 w-full dark:bg-[#121519]'>
// //                     <div className='w-full flex flex-wrap gap-2'>

// //                         <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
// //                             <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Campaign Name</label>
// //                             <input
// //                                 value={CampaignName}
// //                                 onChange={e => setCampaignName(e.target.value)}
// //                                 className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
// //                                 type="text" placeholder="Search campaign..."
// //                             />
// //                         </div>

// //                         <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
// //                             <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Template Type</label>
// //                             <select
// //                                 value={TemplateType}
// //                                 onChange={e => setTemplateType(e.target.value)}
// //                                 className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
// //                             >
// //                                 <option value="">All Types</option>
// //                                 <option value="marketing">Marketing</option>
// //                                 <option value="utility">Utility</option>
// //                                 <option value="authentication">Authentication</option>
// //                             </select>
// //                         </div>

// //                         <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
// //                             <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Status</label>
// //                             <select
// //                                 value={StatusFilter}
// //                                 onChange={e => setStatusFilter(e.target.value)}
// //                                 className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
// //                             >
// //                                 <option value="">All Status</option>
// //                                 <option value="running">Running</option>
// //                                 <option value="completed">Completed</option>
// //                                 <option value="failed">Failed</option>
// //                                 <option value="scheduled">Scheduled</option>
// //                             </select>
// //                         </div>

// //                         <div className='w-full sm:w-[48%] lg:w-[19%] flex items-center gap-1 mt-4'>
// //                             <button
// //                                 onClick={applyFilter}
// //                                 className='flex items-center justify-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-white w-full sm:w-auto transition-colors'
// //                             >
// //                                 <FaFilter /><span className='text-[12px] font-bold'>Filter</span>
// //                             </button>
// //                             <button
// //                                 onClick={clearFilter}
// //                                 className='flex items-center justify-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-white w-full sm:w-auto transition-colors'
// //                             >
// //                                 <TbReload /><span className='text-[12px] font-bold'>Clear</span>
// //                             </button>
// //                         </div>

// //                     </div>
// //                 </div>
// //             )}

// //             {/* Error */}
// //             {error && (
// //                 <div className='w-full bg-red-50 border border-red-200 text-red-600 text-[12px] px-4 py-2 rounded-md mb-2'>
// //                     {error}
// //                 </div>
// //             )}

// //             {/* Table */}
// //             <div className='overflow-x-auto'>
// //                 <table className="w-full overflow-hidden border border-[#dee2e6]">
// //                     <thead>
// //                         <tr className="text-left">
// //                             {columns.map(col => (
// //                                 <th key={col} className="p-1 cursor-pointer border border-[#dee2e6] bg-[#f6f9fc] dark:bg-[#1a1f24]">
// //                                     <div className="flex justify-between items-center gap-2">
// //                                         <span className='text-[11px] text-[#576071] dark:text-white font-semibold'>{col}</span>
// //                                         {col !== 'Action' && col !== '#' && (
// //                                             <button type="button" className="text-gray-400 hover:text-black">
// //                                                 <TbArrowsSort />
// //                                             </button>
// //                                         )}
// //                                     </div>
// //                                 </th>
// //                             ))}
// //                         </tr>
// //                     </thead>
// //                     <tbody>
// //                         {loading ? (
// //                             <tr className="text-center bg-[#f6f9fc] dark:bg-[#121519]">
// //                                 <td colSpan={columns.length} className="py-8">
// //                                     <div className="flex items-center justify-center gap-2 text-[12px] text-gray-400">
// //                                         <div className="w-4 h-4 border-2 border-[#37715d] border-t-transparent rounded-full animate-spin" />
// //                                         Loading campaigns...
// //                                     </div>
// //                                 </td>
// //                             </tr>
// //                         ) : pageData.length === 0 ? (
// //                             <tr className="text-center bg-[#f6f9fc] dark:bg-[#121519]">
// //                                 <td colSpan={columns.length} className="py-8 text-[12px] text-gray-400">
// //                                     No campaigns found
// //                                 </td>
// //                             </tr>
// //                         ) : (
// //                             pageData.map((row, i) => (
// //                                 <tr
// //                                     key={row.id || i}
// //                                     className="text-gray-500 odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#e8f0fa] dark:hover:bg-[#2a2f35] transition-colors"
// //                                 >
// //                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white text-gray-400">
// //                                         {indexoffirstuser + i + 1}
// //                                     </td>
// //                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white font-medium">
// //                                         {row.campaign_name || 'Untitled Campaign'}
// //                                     </td>
// //                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white">
// //                                         {row.template_name || '-'}
// //                                     </td>
// //                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white capitalize">
// //                                         {row.template_type || '-'}
// //                                     </td>
// //                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white capitalize">
// //                                         {row.interface || 'web'}
// //                                     </td>
// //                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white font-semibold text-center">
// //                                         {row.total_count ?? '-'}
// //                                     </td>
// //                                     <td className="p-1 text-[11px] border border-[#dee2e6]">
// //                                         <StatusBadge status={row.status} />
// //                                     </td>
// //                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white text-gray-400">
// //                                         {row.created_at ? new Date(row.created_at).toLocaleString() : '-'}
// //                                     </td>
// //                                     <td className="p-1 text-[11px] border border-[#dee2e6]">
// //                                         <button
// //                                             onClick={() => setModalCampaign({ id: row.id, name: row.campaign_name || 'Campaign' })}
// //                                             className='flex items-center gap-1 text-[#3f7fca] hover:text-white hover:bg-[#3f7fca] border border-[#3f7fca] rounded px-2 py-0.5 text-[10px] font-semibold transition-colors'
// //                                         >
// //                                             <FaEye className='text-[10px]' /> View
// //                                         </button>
// //                                     </td>
// //                                 </tr>
// //                             ))
// //                         )}
// //                     </tbody>
// //                 </table>
// //             </div>

// //             {/* Pagination */}
// //             <div className='flex justify-between w-full mt-2'>
// //                 <p className='text-[11px] text-[#3f7fc8] mt-2'>
// //                     Showing {filtered.length === 0 ? 0 : indexoffirstuser + 1} to {Math.min(indexoflastuser, filtered.length)} of {filtered.length} records
// //                 </p>
// //                 <div className="flex items-center mt-2 space-x-2">
// //                     <button
// //                         disabled={currentPage === 1}
// //                         onClick={() => setCurrentPage(p => p - 1)}
// //                         className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
// //                     >Prev</button>
// //                     <p className='text-[11px] text-[#3f7fc8]'>{currentPage} of {totalpages || 1} pages</p>
// //                     <button
// //                         disabled={currentPage >= totalpages}
// //                         onClick={() => setCurrentPage(p => p + 1)}
// //                         className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
// //                     >Next</button>
// //                 </div>
// //             </div>
// //         </>
// //     );
// // }

// // export default CampaignReport;

// import React, { useState, useEffect, useCallback } from 'react';
// import { RiCollapseDiagonalLine } from "react-icons/ri";
// import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
// import { FaFilter } from "react-icons/fa";
// import { TbReload, TbArrowsSort } from "react-icons/tb";
// import { FaDownload, FaEye } from "react-icons/fa6";

// const API_URL = process.env.REACT_APP_API_BASE || '';

// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch { return {}; }
// }

// function getUserIdFromToken() {
//     if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
//         const rawToken = window.locatorgarsotrga("token");
//         if (rawToken) {
//             const decoded = decodeToken(rawToken);
//             return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
//         }
//     }
//     const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
//     if (rawToken) {
//         const decoded = decodeToken(rawToken);
//         return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
//     }
//     return { userId: null, token: null };
// }

// function StatusBadge({ status }) {
//     const s = (status || '').toLowerCase();
//     const map = {
//         running:   'bg-yellow-100 text-yellow-700 border-yellow-200',
//         completed: 'bg-green-100 text-green-700 border-green-200',
//         failed:    'bg-red-100 text-red-600 border-red-200',
//         pending:   'bg-gray-100 text-gray-600 border-gray-200',
//         scheduled: 'bg-blue-100 text-blue-700 border-blue-200',
//     };
//     return (
//         <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border ${map[s] || 'bg-gray-100 text-gray-600 border-gray-200'} capitalize`}>
//             {status || '-'}
//         </span>
//     );
// }

// // ── Campaign Detail Modal ─────────────────────────────────────────────────────
// function CampaignDetailModal({ campaignId, campaignName, onClose }) {
//     const [messages, setMessages] = useState([]);
//     const [loading, setLoading]   = useState(true);
//     const [search, setSearch]     = useState('');
//     const [costMap, setCostMap]   = useState({});  // phone_number → cost
//     const {userId} = getUserIdFromToken();
//     const clientId = userId;
//     useEffect(() => {
//         if (!campaignId) return;
//         (async () => {
//             setLoading(true);
//             try {
//                 const [msgRes, costRes] = await Promise.all([
//                     fetch(`${API_URL}/auth/campaign/${campaignId}`, { credentials: 'include' }),
//                     clientId
//                         ? fetch(`${API_URL}/auth/campaigns/cost-summary/${campaignId}/messages?client_id=${clientId}`, { credentials: 'include' })
//                         : Promise.resolve(null),
//                 ]);

//                 const msgJson = await msgRes.json();
//                 setMessages(msgJson.data || []);

//                 if (costRes) {
//                     const costJson = await costRes.json();
//                     const map = {};
//                     (costJson.data || []).forEach(r => { map[r.phone_number] = r.cost; });
//                     setCostMap(map);
//                 }
//             } catch (e) { console.error(e); }
//             finally { setLoading(false); }
//         })();
//     }, [campaignId, clientId]);

//     const filtered   = messages.filter(m => !search || (m.phone_number || '').includes(search));
//     const statusCount = messages.reduce((acc, m) => { const s = m.status || 'pending'; acc[s] = (acc[s] || 0) + 1; return acc; }, {});
//     const totalCost   = messages.reduce((s, m) => s + (Number(costMap[m.phone_number]) || 0), 0);

//     // Download button for detailed campaign messages
//     const handleDownloadCampaign = () => {
//         const headers = ['#', 'Phone Number', 'Variables', 'Status', 'Cost', 'Sent At'];
//         const rows = filtered.map((m, i) => {
//             let vars = '-';
//             try { vars = JSON.parse(m.variables || '[]').join(', ') || '-'; } catch {}
//             const cost = costMap[m.phone_number];
//             return [
//                 i + 1,
//                 m.phone_number || '-',
//                 vars,
//                 m.status || '-',
//                 `₹${cost != null ? Number(cost).toFixed(4) : '0.0000'}`,
//                 m.created_at ? new Date(m.created_at).toLocaleString() : '-'
//             ];
//         });
//         const csv = [headers, ...rows].map(row => row.map(v => `"${v ?? ''}"`).join(',')).join('\n');
//         const a    = document.createElement('a');
//         a.href     = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
//         a.download = `campaign_${campaignId}_messages.csv`;
//         a.click();
//     };

//     return (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
//             <div className="bg-white dark:bg-[#1a1f24] rounded-xl shadow-2xl w-[90vw] max-w-3xl max-h-[85vh] flex flex-col">
//                 <div className="flex items-center justify-between px-5 py-4 border-b border-[#dee2e6] dark:border-[#2a2f35]">
//                     <div>
//                         <h2 className="text-[14px] font-bold text-[#000] dark:text-white">{campaignName}</h2>
//                         <p className="text-[11px] text-gray-400">
//                             {messages.length} messages &nbsp;·&nbsp;
//                             <span className="text-[#3f7fca] font-semibold">Total Cost: ₹{totalCost.toFixed(4)}</span>
//                         </p>
//                     </div>
//                     <button onClick={onClose} className="text-gray-400 hover:text-red-500 text-[18px] font-bold">✕</button>
//                 </div>
//                 {/* Download Detail Report */}
//                 <div className="flex w-full px-5 py-2 gap-2 justify-end border-b border-[#dee2e6] dark:border-[#2a2f35] bg-white dark:bg-[#1a1f24]">
//                     <button
//                         onClick={handleDownloadCampaign}
//                         className="flex items-center border border-[#3f7fca] rounded-lg px-3 py-1.5 text-[#3f7fca] gap-1 text-[12px] font-bold hover:bg-[#3f7fca] hover:text-white transition-colors"
//                     >
//                         <FaDownload className="text-[12px]" /> Download Detail Report
//                     </button>
//                 </div>
//                 {!loading && (
//                     <div className="flex gap-3 px-5 py-3 bg-[#f6f9fc] dark:bg-[#121519] border-b border-[#dee2e6] dark:border-[#2a2f35] flex-wrap">
//                         {Object.entries(statusCount).map(([s, c]) => (
//                             <div key={s} className="flex items-center gap-1">
//                                 <StatusBadge status={s} />
//                                 <span className="text-[11px] font-bold text-gray-600 dark:text-gray-300">{c}</span>
//                             </div>
//                         ))}
//                     </div>
//                 )}

//                 <div className="px-5 py-2 border-b border-[#dee2e6] dark:border-[#2a2f35]">
//                     <input value={search} onChange={e => setSearch(e.target.value)}
//                         placeholder="Search by phone number..."
//                         className="w-full sm:w-64 text-[12px] border border-[#d4cfcf] rounded-md px-2 py-1.5 outline-none dark:bg-[#121519] dark:text-white" />
//                 </div>

//                 <div className="overflow-auto flex-1">
//                     {loading ? (
//                         <div className="text-center py-10 text-[12px] text-gray-400">Loading messages...</div>
//                     ) : (
//                         <table className="w-full border-collapse">
//                             <thead className="sticky top-0 bg-[#f6f9fc] dark:bg-[#121519]">
//                                 <tr>
//                                     {['#', 'Phone Number', 'Variables', 'Status', 'Cost', 'Sent At'].map(col => (
//                                         <th key={col} className="p-2 text-left text-[11px] font-semibold text-[#576071] dark:text-white border-b border-[#dee2e6]">{col}</th>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filtered.length === 0 ? (
//                                     <tr><td colSpan={6} className="text-center py-6 text-[11px] text-gray-400">No messages found</td></tr>
//                                 ) : filtered.map((m, i) => {
//                                     let vars = '-';
//                                     try { vars = JSON.parse(m.variables || '[]').join(', ') || '-'; } catch {}
//                                     const cost = costMap[m.phone_number];
//                                     return (
//                                         <tr key={m.id || i} className="odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24]">
//                                             <td className="p-2 text-[11px] border-b border-[#dee2e6] text-gray-400">{i + 1}</td>
//                                             <td className="p-2 text-[11px] border-b border-[#dee2e6] dark:text-white font-mono">{m.phone_number || '-'}</td>
//                                             <td className="p-2 text-[11px] border-b border-[#dee2e6] dark:text-white text-gray-500 max-w-[160px] truncate">{vars}</td>
//                                             <td className="p-2 text-[11px] border-b border-[#dee2e6]"><StatusBadge status={m.status} /></td>
//                                             <td className="p-2 text-[11px] border-b border-[#dee2e6] font-semibold">
//                                                 {cost != null
//                                                     ? <span className="text-[#3f7fca]">₹{Number(cost).toFixed(4)}</span>
//                                                     : <span className="text-gray-400">₹0.0000</span>}
//                                             </td>
//                                             <td className="p-2 text-[11px] border-b border-[#dee2e6] dark:text-white text-gray-400">
//                                                 {m.created_at ? new Date(m.created_at).toLocaleString() : '-'}
//                                             </td>
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                             {filtered.length > 0 && (
//                                 <tfoot>
//                                     <tr className="bg-[#f6f9fc] dark:bg-[#1a1f24] font-semibold">
//                                         <td className="p-2 text-[11px] border-t border-[#dee2e6] text-gray-500 dark:text-white" colSpan={4}>Total</td>
//                                         <td className="p-2 text-[11px] border-t border-[#dee2e6] text-[#3f7fca]">
//                                             ₹{filtered.reduce((s, m) => s + (Number(costMap[m.phone_number]) || 0), 0).toFixed(4)}
//                                         </td>
//                                         <td className="p-2 border-t border-[#dee2e6]" />
//                                     </tr>
//                                 </tfoot>
//                             )}
//                         </table>
//                     )}
//                 </div>

//                 <div className="px-5 py-3 border-t border-[#dee2e6] dark:border-[#2a2f35] flex justify-end">
//                     <button onClick={onClose} className="px-4 py-1.5 text-[12px] font-semibold bg-[#37715d] text-white rounded-lg hover:bg-[#2d5e4e] transition-colors">Close</button>
//                 </div>
//             </div>
//         </div>
//     );
// }

// function CampaignReport() {
//     const [showfilter, setshowfilter]     = useState(false);
//     const [CampaignName, setCampaignName] = useState('');
//     const [TemplateType, setTemplateType] = useState('');
//     const [StatusFilter, setStatusFilter] = useState('');
//     const [allData, setAllData]           = useState([]);
//     const [filtered, setFiltered]         = useState([]);
//     const [loading, setLoading]           = useState(false);
//     const [error, setError]               = useState('');
//     const [costMap, setCostMap]           = useState({});  // campaign_id → { total_cost, net_cost, total_refunded }
//     const [modalCampaign, setModalCampaign] = useState(null);
//     const [currentPage, setCurrentPage]   = useState(1);
//     const [usersPerPage, setUsersPerPage] = useState(10);

//     // Make sure currentPage is always in-bounds when usersPerPage or filtered changes.
//     React.useEffect(() => {
//         const totalpages = Math.ceil(filtered.length / usersPerPage) || 1;
//         if (currentPage > totalpages) setCurrentPage(totalpages);
//         if (currentPage < 1) setCurrentPage(1);
//     }, [filtered, currentPage, usersPerPage]);

//     // Derived for every render
//     const indexoflastuser  = currentPage * usersPerPage;
//     const indexoffirstuser = indexoflastuser - usersPerPage;
//     const pageData   = filtered.slice(indexoffirstuser, indexoflastuser);
//     const totalpages = Math.ceil(filtered.length / usersPerPage) || 1;
//     const { userId: clientId } = getUserIdFromToken();

//     // ── FETCH DATA (OPTIMIZED) ───────────────────────────────
//     const fetchData = useCallback(async () => {
//         setLoading(true);

//         try {
//             // ✅ STEP 1: Load campaigns FIRST (FAST)
//             const res = await fetch(`${API_URL}/auth/campaign/report`, {
//                 credentials: 'include'
//             });

//             const json = await res.json();

//             setAllData(json.data || []);
//             setFiltered(json.data || []);
//             setCurrentPage(1); // reset page on new data!

//             // ✅ STEP 2: Load cost in background (NON-BLOCKING)
//             if (clientId) {
//                 fetch(`${API_URL}/auth/campaigns/cost-summary?client_id=${clientId}`, {
//                     credentials: 'include'
//                 })
//                     .then(r => r.json())
//                     .then(costJson => {
//                         const map = {};
//                         (costJson.data || []).forEach(r => {
//                             map[r.campaign_id] = {
//                                 total_cost: Number(r.total_cost) || 0,
//                                 net_cost: Number(r.net_cost) || 0,
//                                 total_refunded: Number(r.total_refunded) || 0,
//                             };
//                         });
//                         setCostMap(map);
//                     })
//                     .catch(() => { });
//             }

//         } catch (e) {
//             console.error(e);
//         }

//         setLoading(false);
//     }, [clientId]);

//     useEffect(() => {
//         fetchData();
//     }, [fetchData]);

//     // When applying filter, page always to 1
//     const applyFilter = () => {
//         let d = [...allData];
//         if (CampaignName) d = d.filter(r => (r.campaign_name || '').toLowerCase().includes(CampaignName.toLowerCase()));
//         if (TemplateType) d = d.filter(r => r.template_type === TemplateType);
//         if (StatusFilter) d = d.filter(r => (r.status || '').toLowerCase() === StatusFilter.toLowerCase());
//         setFiltered(d);
//         setCurrentPage(1);
//     };

//     // Clear also resets page
//     const clearFilter = () => {
//         setCampaignName('');
//         setTemplateType('');
//         setStatusFilter('');
//         setFiltered(allData);
//         setCurrentPage(1);
//     };

//     // Download main campaign summary CSV
//     const handleDownload = () => {
//         const headers = ['ID', 'Campaign Name', 'Template', 'Type', 'Interface', 'Total', 'Status', 'Total Cost', 'Refunded', 'Net Cost', 'Created At'];
//         const rows = filtered.map(r => {
//             const c = costMap[r.id] || {};
//             return [r.id, r.campaign_name, r.template_name, r.template_type, r.interface, r.total_count, r.status,
//                 (c.total_cost || 0).toFixed(4), (c.total_refunded || 0).toFixed(4), (c.net_cost || 0).toFixed(4),
//                 r.created_at ? new Date(r.created_at).toLocaleString() : ''];
//         });
//         const csv  = [headers, ...rows].map(row => row.map(v => `"${v ?? ''}"`).join(',')).join('\n');
//         const a    = document.createElement('a');
//         a.href     = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
//         a.download = 'campaign_report.csv'; a.click();
//     };

//     const grandTotal     = filtered.reduce((s, r) => s + (costMap[r.id]?.total_cost     || 0), 0);
//     const grandRefunded  = filtered.reduce((s, r) => s + (costMap[r.id]?.total_refunded || 0), 0);
//     const grandNet       = filtered.reduce((s, r) => s + (costMap[r.id]?.net_cost       || 0), 0);
//     const columns = ['#', 'Campaign Name', 'Template Name', 'Template Type', 'Interface', 'Total', 'Status', 'Total Cost', 'Refunded', 'Net Cost', 'Created At', 'Action'];

//     return (
//         <>
//             {modalCampaign && (
//                 <CampaignDetailModal campaignId={modalCampaign.id} campaignName={modalCampaign.name} onClose={() => setModalCampaign(null)} />
//             )}

//             {/* Summary Cards */}
//             {!loading && allData.length > 0 && (
//                 <div className='grid grid-cols-3 gap-2 mb-3'>
//                     {[
//                         { label: 'Total Spent',    value: `₹${grandTotal.toFixed(4)}`,    color: 'text-red-500' },
//                         { label: 'Total Refunded', value: `₹${grandRefunded.toFixed(4)}`, color: 'text-green-600' },
//                         { label: 'Net Cost',       value: `₹${grandNet.toFixed(4)}`,      color: 'text-[#3f7fca]' },
//                     ].map(card => (
//                         <div key={card.label} className='border border-[#dee2e6] rounded-lg px-3 py-2 dark:border-[#2a3040]'>
//                             <p className='text-[10px] text-gray-400'>{card.label}</p>
//                             <p className={`text-[13px] font-bold ${card.color}`}>{card.value}</p>
//                         </div>
//                     ))}
//                 </div>
//             )}

//             {/* Actions */}
//             <div className='w-full flex items-center justify-between mb-2'>
//                 <p className='text-[12px] text-gray-500 dark:text-gray-400'>Total: <span className='font-bold text-[#37715d]'>{allData.length}</span> campaigns</p>
//                 <div className='flex gap-2'>
//                     <button onClick={fetchData} className='flex items-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-1 hover:bg-[#37715d] hover:text-white transition-colors'>
//                         <TbReload className='text-[13px]' /><span className='text-[12px] font-bold'>Refresh</span>
//                     </button>
//                     {/* Download Campaign Report button */}
//                     <button onClick={handleDownload} className='flex items-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-1 hover:bg-[#3f7fca] hover:text-white transition-colors'>
//                         <FaDownload className='text-[12px]' /><span className='text-[12px] font-bold'>Download</span>
//                     </button>
//                 </div>
//             </div>

//             {/* Filter */}
//             <div onClick={() => setshowfilter(!showfilter)} className='w-full flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] cursor-pointer'>
//                 <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-white'><RiCollapseDiagonalLine /> Filter Records</div>
//                 <div className='flex items-center text-[#576071] dark:text-white'>{showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}</div>
//             </div>
//             {showfilter && (
//                 <div className='bg-[#edf1f5] py-2 px-4 w-full dark:bg-[#121519]'>
//                     <div className='w-full flex flex-wrap gap-2'>
//                         <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Campaign Name</label>
//                             <input value={CampaignName} onChange={e => setCampaignName(e.target.value)} type="text" placeholder="Search..."
//                                 className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white' />
//                         </div>
//                         <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Template Type</label>
//                             <select value={TemplateType} onChange={e => setTemplateType(e.target.value)}
//                                 className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'>
//                                 <option value="">All Types</option>
//                                 <option value="marketing">Marketing</option>
//                                 <option value="utility">Utility</option>
//                                 <option value="authentication">Authentication</option>
//                             </select>
//                         </div>
//                         <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Status</label>
//                             <select value={StatusFilter} onChange={e => setStatusFilter(e.target.value)}
//                                 className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'>
//                                 <option value="">All Status</option>
//                                 <option value="running">Running</option>
//                                 <option value="completed">Completed</option>
//                                 <option value="failed">Failed</option>
//                                 <option value="scheduled">Scheduled</option>
//                             </select>
//                         </div>
//                         <div className='w-full sm:w-[48%] lg:w-[19%] flex items-center gap-1 mt-4'>
//                             <button onClick={applyFilter} className='flex items-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-white transition-colors'>
//                                 <FaFilter /><span className='text-[12px] font-bold'>Filter</span>
//                             </button>
//                             <button onClick={clearFilter} className='flex items-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-white transition-colors'>
//                                 <TbReload /><span className='text-[12px] font-bold'>Clear</span>
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {error && <div className='w-full bg-red-50 border border-red-200 text-red-600 text-[12px] px-4 py-2 rounded-md mb-2'>{error}</div>}

//             {/* Table */}
//             <div className='overflow-x-auto'>
//                 <table className="w-full overflow-hidden border border-[#dee2e6]">
//                     <thead>
//                         <tr className="text-left">
//                             {columns.map(col => (
//                                 <th key={col} className="p-1 border border-[#dee2e6] bg-[#f6f9fc] dark:bg-[#1a1f24]">
//                                     <div className="flex justify-between items-center gap-2">
//                                         <span className='text-[11px] text-[#576071] dark:text-white font-semibold whitespace-nowrap'>{col}</span>
//                                         {col !== 'Action' && col !== '#' && <button type="button" className="text-gray-400 hover:text-black"><TbArrowsSort /></button>}
//                                     </div>
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             <tr><td colSpan={columns.length} className="py-8 text-center">
//                                 <div className="flex items-center justify-center gap-2 text-[12px] text-gray-400">
//                                     <div className="w-4 h-4 border-2 border-[#37715d] border-t-transparent rounded-full animate-spin" />Loading...
//                                 </div>
//                             </td></tr>
//                         ) : pageData.length === 0 ? (
//                             <tr><td colSpan={columns.length} className="py-8 text-center text-[12px] text-gray-400">No campaigns found</td></tr>
//                         ) : pageData.map((row, i) => {
//                             const cost = costMap[row.id] || { total_cost: 0, net_cost: 0, total_refunded: 0 };
//                             return (
//                                 <tr key={row.id || i} className="odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#e8f0fa] dark:hover:bg-[#2a2f35] transition-colors">
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] text-gray-400">{indexoffirstuser + i + 1}</td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white font-medium">{row.campaign_name || 'Untitled'}</td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white">{row.template_name || '-'}</td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white capitalize">{row.template_type || '-'}</td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white capitalize">{row.interface || 'web'}</td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white text-center font-semibold">{row.total_count ?? '-'}</td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6]"><StatusBadge status={row.status} /></td>
//                                     {/* ── Cost columns ── */}
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] text-[#3f7fca] font-semibold whitespace-nowrap">
//                                         ₹{cost.total_cost.toFixed(4)}
//                                     </td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] font-semibold whitespace-nowrap">
//                                         {cost.total_refunded > 0
//                                             ? <span className="text-green-600">₹{cost.total_refunded.toFixed(4)}</span>
//                                             : <span className="text-gray-400">₹0.0000</span>}
//                                     </td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] text-orange-500 font-semibold whitespace-nowrap">
//                                         ₹{cost.net_cost.toFixed(4)}
//                                     </td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white text-gray-400 whitespace-nowrap">
//                                         {row.created_at ? new Date(row.created_at).toLocaleString() : '-'}
//                                     </td>
//                                     <td className="p-1 text-[11px] border border-[#dee2e6]">
//                                         <button onClick={() => setModalCampaign({ id: row.id, name: row.campaign_name || 'Campaign' })}
//                                             className='flex items-center gap-1 text-[#3f7fca] hover:text-white hover:bg-[#3f7fca] border border-[#3f7fca] rounded px-2 py-0.5 text-[10px] font-semibold transition-colors'>
//                                             <FaEye className='text-[10px]' /> View
//                                         </button>
//                                     </td>
//                                 </tr>
//                             );
//                         })}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Pagination */}
//             <div className='flex flex-col md:flex-row md:items-center md:justify-between w-full mt-2 gap-2'>
//                 <div className="flex items-center gap-1">
//                     <span className="text-[11px] text-[#576071] dark:text-[#ccc]">Show</span>
//                     <select
//                         className="text-[11px] px-1 py-0.5 rounded border border-gray-300 bg-white dark:bg-[#191d22] dark:text-white"
//                         value={usersPerPage}
//                         onChange={e => {
//                             setUsersPerPage(Number(e.target.value));
//                             setCurrentPage(1); // Reset page on change
//                         }}
//                     >
//                         <option value={10}>10</option>
//                         <option value={20}>20</option>
//                         <option value={50}>50</option>
//                         <option value={100}>100</option>
//                     </select>
//                     <span className="text-[11px] text-[#576071] dark:text-[#ccc]">entries</span>
//                 </div>
//                 <p className='text-[11px] text-[#3f7fc8] mt-2'>
//                     {/* Debug info */}
//                     {/* filtered: {filtered.length} | totalpages: {totalpages} | currentPage: {currentPage} | from {filtered.length > 0 ? indexoffirstuser + 1 : 0} to {Math.min(indexoflastuser, filtered.length)} */}
//                     Showing {filtered.length === 0 ? 0 : indexoffirstuser + 1} to {Math.min(indexoflastuser, filtered.length)} of {filtered.length} records
//                 </p>
//                 <div className="flex items-center mt-2 space-x-2">
//                     <button
//                         disabled={currentPage === 1}
//                         onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
//                         className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
//                     >Prev</button>
//                     <p className='text-[11px] text-[#3f7fc8]'>{currentPage} of {totalpages || 1} pages</p>
//                     <button
//                         disabled={currentPage >= totalpages}
//                         onClick={() => setCurrentPage(p => Math.min(totalpages, p + 1))}
//                         className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
//                     >Next</button>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default CampaignReport;

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload, TbArrowsSort } from "react-icons/tb";
import { FaDownload, FaEye, FaList } from "react-icons/fa6";
import { HiMenuAlt2 } from "react-icons/hi";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from 'recharts';

// Removed all es-toolkit/compat or es-toolkit/dist/compat or es-toolkit/dist/compat/array, object, function, math, predicate, util usage

const API_URL = process.env.REACT_APP_API_BASE || '';

// ── Token helpers ─────────────────────────────────────────────────────────────
function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}

// ── Status Badge ──────────────────────────────────────────────────────────────
function StatusBadge({ status }) {
    const s = (status || '').toLowerCase();
    const map = {
        running:   'bg-yellow-100 text-yellow-700 border-yellow-200',
        completed: 'bg-green-100 text-green-700 border-green-200',
        failed:    'bg-red-100 text-red-600 border-red-200',
        pending:   'bg-gray-100 text-gray-600 border-gray-200',
        scheduled: 'bg-blue-100 text-blue-700 border-blue-200',
    };
    return (
        <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border ${map[s] || 'bg-gray-100 text-gray-600 border-gray-200'} capitalize`}>
            {status || '-'}
        </span>
    );
}

// ── Row Action Menu (hamburger) ───────────────────────────────────────────────
function RowActionMenu({ row, onViewDelivery, onDownloadRow }) {
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(e) {
            if (menuRef.current && !menuRef.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative inline-block" ref={menuRef}>
            <button
                onClick={() => setOpen(o => !o)}
                className="flex items-center gap-1 border border-gray-400 rounded px-2 py-0.5 text-[10px] font-semibold text-gray-600 hover:bg-gray-100 transition-colors"
                title="Actions"
            >
                <HiMenuAlt2 className="text-[13px]" />
            </button>
            {open && (
                <div className="absolute right-0 z-50 mt-1 w-44 bg-white dark:bg-[#1a1f24] border border-[#dee2e6] dark:border-[#2a2f35] rounded-lg shadow-xl">
                    <button
                        onClick={() => { onViewDelivery(row); setOpen(false); }}
                        className="flex items-center gap-2 w-full px-3 py-2 text-[11px] text-gray-700 dark:text-white hover:bg-[#edf1f5] dark:hover:bg-[#2a2f35] transition-colors"
                    >
                        <FaList className="text-[#576071] text-[11px]" /> View Details
                    </button>
                    <button
                        onClick={() => { onViewDelivery(row, 'status'); setOpen(false); }}
                        className="flex items-center gap-2 w-full px-3 py-2 text-[11px] text-gray-700 dark:text-white hover:bg-[#edf1f5] dark:hover:bg-[#2a2f35] transition-colors"
                    >
                        <FaEye className="text-[#3f7fca] text-[11px]" /> Delivery Report
                    </button>
                    <button
                        onClick={() => { onDownloadRow(row); setOpen(false); }}
                        className="flex items-center gap-2 w-full px-3 py-2 text-[11px] text-gray-700 dark:text-white hover:bg-[#edf1f5] dark:hover:bg-[#2a2f35] transition-colors"
                    >
                        <FaDownload className="text-[#37715d] text-[11px]" /> Download CSV
                    </button>
                </div>
            )}
        </div>
    );
}

// ── WhatsApp Template Preview ─────────────────────────────────────────────────
function WhatsAppPreview({ campaign }) {
    const bodyText = campaign?.template_body || campaign?.body_text || '';
    const headerFormat = (campaign?.header_format || '').toUpperCase();
    const headerUrl = campaign?.header_url || '';
    const buttons = campaign?.buttons || [];

    return (
        <div style={{ height: 650, backgroundColor: '#ECE5DD', boxShadow: '0 0 15px rgba(0,0,0,0.2)', borderRadius: 10 }}>
            {/* WhatsApp Header Bar */}
            <div style={{
                background: 'linear-gradient(135deg, #16697a 0%, #1a4d5c 100%)',
                height: 60, borderRadius: '10px 10px 0 0',
                display: 'flex', alignItems: 'center', padding: '0 16px', gap: 10
            }}>
                <span style={{ color: '#fff', fontSize: 20 }}>←</span>
                <span style={{ color: '#fff', fontSize: 18 }}>💬</span>
                <span style={{ color: '#fff', fontSize: 14, fontWeight: 600, flex: 1 }}>WhatsApp</span>
                <span style={{ color: '#fff', fontSize: 16 }}>🔍</span>
                <span style={{ color: '#fff', fontSize: 16 }}>⋮</span>
            </div>

            {/* Chat Body */}
            <div style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23B0B0B0' fill-opacity='0.15' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zm1 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`,
                overflowY: 'auto', maxHeight: 549, padding: '16px 12px'
            }}>
                {/* Message Bubble */}
                <div style={{
                    backgroundColor: '#fff', borderRadius: 8, borderTopLeftRadius: 0,
                    padding: 12, maxWidth: '90%', position: 'relative',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.15)'
                }}>
                    {/* Header media */}
                    {headerFormat === 'IMAGE' && headerUrl && (
                        <img src={headerUrl} alt="header" style={{ width: '100%', borderRadius: 4, marginBottom: 8 }} />
                    )}
                    {headerFormat === 'VIDEO' && (
                        <div style={{
                            width: '100%', height: 120, background: '#000', borderRadius: 4,
                            marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            <span style={{ color: '#fff', fontSize: 32 }}>▶</span>
                        </div>
                    )}
                    {headerFormat === 'DOCUMENT' && (
                        <div style={{
                            display: 'flex', alignItems: 'center', gap: 8, padding: '8px',
                            background: '#f0f0f0', borderRadius: 4, marginBottom: 8
                        }}>
                            <span style={{ fontSize: 24 }}>📄</span>
                            <span style={{ fontSize: 12, color: '#555' }}>Document</span>
                        </div>
                    )}
                    {/* Text header */}
                    {headerFormat === 'TEXT' && campaign?.header_text && (
                        <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6, color: '#111' }}>
                            {campaign.header_text}
                        </div>
                    )}

                    {/* Body text */}
                    {bodyText ? (
                        <div style={{ fontSize: 13, color: '#1e1e1e', whiteSpace: 'pre-line', lineHeight: 1.4 }}>
                            {bodyText}
                        </div>
                    ) : (
                        <div style={{ fontSize: 12, color: '#999', fontStyle: 'italic' }}>No template body</div>
                    )}

                    {/* Footer */}
                    {campaign?.footer_text && (
                        <div style={{ fontSize: 11, color: '#6c6d6d', marginTop: 4 }}>{campaign.footer_text}</div>
                    )}

                    {/* Timestamp */}
                    <div style={{ fontSize: 11, color: '#6c757d', textAlign: 'right', marginTop: 6 }}>9:10 AM</div>

                    {/* Buttons */}
                    {buttons.length > 0 && (
                        <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
                            {buttons.map((btn, idx) => (
                                <div key={idx} style={{
                                    border: '1px solid #0d6efd', borderRadius: 4, padding: '4px 8px',
                                    textAlign: 'center', fontSize: 12, color: '#0d6efd', cursor: 'pointer'
                                }}>
                                    {btn.text || btn}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

// ── Delivery Status Tab Grid ──────────────────────────────────────────────────
function StatusTabContent({ messages, status, costMap }) {
    const [search, setSearch] = useState('');

    const tabMessages = status === 'OverView'
        ? messages
        : messages.filter(m => (m.status || '').toLowerCase() === status.toLowerCase());

    const filtered = tabMessages.filter(m => !search || (m.phone_number || '').includes(search));

    // No es-toolkit/compat or lodash; use plain reduce etc
    const PIE_COLORS = ['#007bff','#17a2b8','#ffc107','#28a745','#dc3545','#6c757d','#6610f2'];
    const statusCount = messages.reduce((acc, m) => {
        const s = (m.status || 'pending').toLowerCase();
        acc[s] = (acc[s] || 0) + 1;
        return acc;
    }, {});
    const pieData = [
        { name: 'Sent',      value: statusCount['sent']      || 0 },
        { name: 'Delivered', value: statusCount['delivered'] || 0 },
        { name: 'Read',      value: statusCount['read']      || 0 },
        { name: 'Submitted', value: statusCount['submitted'] || 0 },
        { name: 'Failed',    value: statusCount['failed']    || 0 },
        { name: 'Sending',   value: statusCount['sending']   || 0 },
        { name: 'Replied',   value: statusCount['replied']   || 0 },
    ].filter(d => d.value > 0);

    return (
        <div style={{ display: 'flex', gap: 16, paddingTop: 16, width: '99%' }}>
            {/* Pie Chart */}
            <div style={{ width: 300, flexShrink: 0 }}>
                <div style={{ position: 'relative', width: 300, height: 280, margin: '0 auto' }}>
                    {pieData.length > 0 ? (
                        <ResponsiveContainer width="100%" height={280}>
                            <PieChart>
                                <Pie data={pieData} cx="50%" cy="50%" outerRadius={90} dataKey="value" label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`} labelLine={false} fontSize={10}>
                                    {pieData.map((_, index) => (
                                        <Cell key={index} fill={PIE_COLORS[index % PIE_COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip />
                                <Legend wrapperStyle={{ fontSize: 11 }} />
                            </PieChart>
                        </ResponsiveContainer>
                    ) : (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 280, color: '#999', fontSize: 13 }}>
                            No data to chart
                        </div>
                    )}
                </div>
            </div>

            {/* Grid */}
            <div style={{ flex: 1, overflow: 'auto' }}>
                <div style={{ marginBottom: 8 }}>
                    <input
                        value={search} onChange={e => setSearch(e.target.value)}
                        placeholder="Search by phone number..."
                        style={{
                            fontSize: 12, border: '1px solid #d4cfcf', borderRadius: 6,
                            padding: '5px 8px', outline: 'none', width: 220
                        }}
                    />
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #dee2e6', fontSize: 11 }}>
                    <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f6f9fc' }}>
                        <tr>
                            {['#', 'Phone Number', 'Variables', 'Status', 'Cost', 'Sent At'].map(col => (
                                <th key={col} style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 600, color: '#576071', borderBottom: '1px solid #dee2e6', whiteSpace: 'nowrap' }}>{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.length === 0 ? (
                            <tr><td colSpan={6} style={{ textAlign: 'center', padding: 24, color: '#999' }}>No messages found</td></tr>
                        ) : filtered.map((m, i) => {
                            let vars = '-';
                            try { vars = JSON.parse(m.variables || '[]').join(', ') || '-'; } catch {}
                            const cost = costMap[m.phone_number];
                            return (
                                <tr key={m.id || i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#edf1f5' }}>
                                    <td style={{ padding: '5px 8px', borderBottom: '1px solid #dee2e6', color: '#999' }}>{i + 1}</td>
                                    <td style={{ padding: '5px 8px', borderBottom: '1px solid #dee2e6', fontFamily: 'monospace' }}>{m.phone_number || '-'}</td>
                                    <td style={{ padding: '5px 8px', borderBottom: '1px solid #dee2e6', color: '#666', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{vars}</td>
                                    <td style={{ padding: '5px 8px', borderBottom: '1px solid #dee2e6' }}>
                                        <StatusBadge status={m.status} />
                                    </td>
                                    <td style={{ padding: '5px 8px', borderBottom: '1px solid #dee2e6', fontWeight: 600, color: cost != null ? '#3f7fca' : '#999', whiteSpace: 'nowrap' }}>
                                        ₹{cost != null ? Number(cost).toFixed(4) : '0.0000'}
                                    </td>
                                    <td style={{ padding: '5px 8px', borderBottom: '1px solid #dee2e6', color: '#666', whiteSpace: 'nowrap' }}>
                                        {m.created_at ? new Date(m.created_at).toLocaleString() : '-'}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

// ── Delivery Report Modal ─────────────────────────────────────────────────────
function DeliveryReportModal({ campaign, onClose }) {
    const [activeTab, setActiveTab] = useState('OverView');
    const [messages, setMessages]   = useState([]);
    const [loading, setLoading]     = useState(true);
    const [costMap, setCostMap]     = useState({});
    const { userId: clientId } = getUserIdFromToken();

    const tabs = [
        { key: 'OverView',  label: 'OverView',  icon: '☰',  cls: '' },
        { key: 'Sending',   label: 'Sending',   icon: '✓',  cls: '' },
        { key: 'Submitted', label: 'Submitted', icon: '🖱', cls: '' },
        { key: 'Sent',      label: 'Sent',      icon: '✓',  cls: '' },
        { key: 'Delivered', label: 'Delivered', icon: '✓✓', cls: '' },
        { key: 'Read',      label: 'Read',      icon: '✓✓', cls: 'text-green-500' },
        { key: 'Replied',   label: 'Replied',   icon: '↩',  cls: 'text-cyan-500' },
        { key: 'Failed',    label: 'Failed',    icon: '✕',  cls: 'text-red-500' },
    ];

    const fetchMessages = useCallback(async () => {
        if (!campaign?.id) return;
        setLoading(true);
        try {
            const [msgRes, costRes] = await Promise.all([
                fetch(`${API_URL}/auth/campaign/${campaign.id}`, { credentials: 'include' }),
                clientId
                    ? fetch(`${API_URL}/auth/campaigns/cost-summary/${campaign.id}/messages?client_id=${clientId}`, { credentials: 'include' })
                    : Promise.resolve(null),
            ]);
            const msgJson = await msgRes.json();
            setMessages(msgJson.data || []);
            if (costRes) {
                const costJson = await costRes.json();
                const map = {};
                (costJson.data || []).forEach(r => { map[r.phone_number] = r.cost; });
                setCostMap(map);
            }
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    }, [campaign?.id, clientId]);

    useEffect(() => { fetchMessages(); }, [fetchMessages]);

    // Compute delivery counts from messages - with plain JS
    const statusCount = messages.reduce((acc, m) => {
        const s = (m.status || 'pending').toLowerCase();
        acc[s] = (acc[s] || 0) + 1;
        return acc;
    }, {});

    const totalCount   = messages.length;
    const deliveryCounts = {
        TotalCount:     totalCount,
        SentCount:      statusCount['sent']      || 0,
        DeliveredCount: statusCount['delivered'] || 0,
        SendingCount:   statusCount['sending']   || 0,
        ReadCount:      statusCount['read']      || 0,
        SubmittedCount: statusCount['submitted'] || 0,
        FailedCount:    statusCount['failed']    || 0,
        RepliedCount:   statusCount['replied']   || 0,
    };

    const getTabCount = (key) => {
        if (key === 'OverView') return totalCount;
        return statusCount[key.toLowerCase()] || 0;
    };

    const getPct = (key) => {
        const c = getTabCount(key);
        return totalCount > 0 ? ((c / totalCount) * 100).toFixed(1) : '0.0';
    };

    const totalCost = messages.reduce((s, m) => s + (Number(costMap[m.phone_number]) || 0), 0);

    const handleDownload = () => {
        const tabMessages = activeTab === 'OverView'
            ? messages
            : messages.filter(m => (m.status || '').toLowerCase() === activeTab.toLowerCase());
        const headers = ['#', 'Phone Number', 'Variables', 'Status', 'Cost', 'Sent At'];
        const rows = tabMessages.map((m, i) => {
            let vars = '-';
            try { vars = JSON.parse(m.variables || '[]').join(', ') || '-'; } catch {}
            const cost = costMap[m.phone_number];
            return [i + 1, m.phone_number || '-', vars, m.status || '-',
                `₹${cost != null ? Number(cost).toFixed(4) : '0.0000'}`,
                m.created_at ? new Date(m.created_at).toLocaleString() : '-'];
        });
        const csv = [headers, ...rows].map(r => r.map(v => `"${v ?? ''}"`).join(',')).join('\n');
        const a = document.createElement('a');
        a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
        a.download = `campaign_${campaign.id}_${activeTab}.csv`;
        a.click();
    };

    // Campaign detail items for the left card
    const detailItems = [
        { icon: '📣', label: 'Campaign Type',  value: campaign.campaign_type || campaign.type || 'Normal' },
        { icon: '📄', label: 'Message Type',   value: campaign.template_type || '-' },
        { icon: '🏷', label: 'Template Name',  value: campaign.template_name || '-' },
        { icon: '📅', label: 'Created At',     value: campaign.created_at ? new Date(campaign.created_at).toLocaleString('en-IN', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '-' },
        { icon: '✅', label: 'Completed At',   value: campaign.completed_at ? new Date(campaign.completed_at).toLocaleString('en-IN', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '-' },
    ];

    // Stats cards for center panel (matching the HTML exactly)
    const statCards = [
        { label: 'Status',            value: (campaign.status || 'COMPLETED').toUpperCase(), cls: 'text-green-600' },
        { label: 'Audience',          value: totalCount,                        cls: 'text-cyan-600' },
        { label: 'Total Credit Usage',value: totalCost.toFixed(4),             cls: 'text-gray-800' },
        { label: 'Sending',           value: deliveryCounts.SendingCount,       cls: 'text-yellow-500' },
        { label: 'Sent',              value: deliveryCounts.SentCount,          cls: 'text-blue-600' },
        { label: 'Delivered',         value: deliveryCounts.DeliveredCount,     cls: 'text-cyan-600' },
        { label: 'Read',              value: deliveryCounts.ReadCount,          cls: 'text-gray-800' },
        { label: 'Submitted',         value: deliveryCounts.SubmittedCount,     cls: 'text-green-600' },
        { label: 'Failed',            value: deliveryCounts.FailedCount,        cls: 'text-red-500' },
        { label: 'Replied',           value: deliveryCounts.RepliedCount,       cls: 'text-cyan-600' },
    ];

    const PIE_COLORS = ['#007bff','#17a2b8','#ffc107','#28a745','#dc3545','#6c757d','#6610f2'];
    const pieData = [
        { name: 'Sent',      value: deliveryCounts.SentCount },
        { name: 'Delivered', value: deliveryCounts.DeliveredCount },
        { name: 'Read',      value: deliveryCounts.ReadCount },
        { name: 'Submitted', value: deliveryCounts.SubmittedCount },
        { name: 'Failed',    value: deliveryCounts.FailedCount },
        { name: 'Sending',   value: deliveryCounts.SendingCount },
        { name: 'Replied',   value: deliveryCounts.RepliedCount },
    ].filter(d => d.value > 0);

    return (
        <div className="fixed inset-0 z-50 bg-white dark:bg-[#1a1f24] flex flex-col overflow-hidden">

            {/* ── Modal Header ── */}
            <div className="flex items-center justify-between px-4 py-2 border-b border-[#dee2e6] dark:border-[#2a2f35] bg-white dark:bg-[#1a1f24] flex-shrink-0">
                <h5 className="text-[14px] font-semibold text-gray-800 dark:text-white flex items-center gap-2">
                    <button onClick={onClose} className="text-blue-500 hover:text-blue-700 mr-1 text-[16px]">←</button>
                    Delivery Status Report
                </h5>
                <div className="flex items-center gap-2">
                    <button
                        onClick={fetchMessages}
                        className="flex items-center gap-1 border border-[#3f7fca] rounded px-2 py-1 text-[11px] text-[#3f7fca] hover:bg-[#3f7fca] hover:text-white transition-colors font-semibold"
                    >
                        <TbReload className="text-[12px]" /> Refresh
                    </button>
                    <button
                        onClick={handleDownload}
                        className="flex items-center gap-1 border border-[#37715d] rounded px-2 py-1 text-[11px] text-[#37715d] hover:bg-[#37715d] hover:text-white transition-colors font-semibold"
                    >
                        <FaDownload className="text-[10px]" /> Download CSV
                    </button>
                    <button onClick={onClose} className="text-gray-400 hover:text-red-500 text-[18px] font-bold leading-none">✕</button>
                </div>
            </div>

            {/* ── Nav Tabs (exact match to HTML) ── */}
            <div className="flex items-center justify-center gap-0 bg-[#f8f9fa] border-b border-[#dee2e6] overflow-x-auto flex-shrink-0">
                {tabs.map(tab => {
                    const count = getTabCount(tab.key);
                    const pct   = getPct(tab.key);
                    const isActive = activeTab === tab.key;
                    return (
                        <button
                            key={tab.key}
                            onClick={() => setActiveTab(tab.key)}
                            className={`flex flex-col items-center px-5 py-2 border-b-2 transition-all whitespace-nowrap min-w-[80px] ${
                                isActive
                                    ? 'border-[#0d6efd] bg-white text-[#0d6efd]'
                                    : 'border-transparent text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                            }`}
                        >
                            <span className="text-[12px] font-bold leading-tight">
                                {pct}% <span className="font-normal text-[11px]">({count})</span>
                            </span>
                            <span className={`text-[11px] mt-0.5 ${tab.cls}`}>
                                {tab.icon}&nbsp;{tab.label}
                            </span>
                        </button>
                    );
                })}
            </div>

            {/* ── Tab Content ── */}
            <div className="flex-1 overflow-auto bg-[#6c757d26]" style={{ padding: 0 }}>
                {loading ? (
                    <div className="flex items-center justify-center h-full gap-2 text-[13px] text-gray-500">
                        <div className="w-5 h-5 border-2 border-[#37715d] border-t-transparent rounded-full animate-spin" />
                        Loading...
                    </div>
                ) : (
                    <>
                        {/* ══ OVERVIEW TAB ══ */}
                        {activeTab === 'OverView' && (
                            <div className="p-3 h-full">
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr', gap: 16, height: '100%' }}>

                                    {/* ── LEFT: Campaign Details Card ── */}
                                    <div>
                                        <div className="bg-white dark:bg-[#1a1f24] rounded border-0 shadow-sm">
                                            <div className="p-4">
                                                <h6 className="text-[13px] font-semibold text-gray-800 dark:text-white mb-3 flex items-center gap-2">
                                                    Campaign Details <FaList className="text-[11px]" />
                                                </h6>
                                                <hr className="border-[#dee2e6] mb-3" />
                                                <div className="flex flex-col gap-3">
                                                    {detailItems.map(item => (
                                                        <div key={item.label} className="flex items-start gap-3">
                                                            <div style={{
                                                                width: 34, height: 34, minWidth: 34,
                                                                background: 'rgb(233,237,239)',
                                                                borderRadius: 4, display: 'flex',
                                                                alignItems: 'center', justifyContent: 'center',
                                                                color: 'rgb(0,128,105)', fontSize: 15
                                                            }}>
                                                                {item.icon}
                                                            </div>
                                                            <div>
                                                                <div className="text-[11px] text-gray-400">{item.label}</div>
                                                                <div className="text-[12px] font-medium text-gray-800 dark:text-white">{item.value}</div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ── CENTER: Stats Cards + Pie Chart ── */}
                                    <div>
                                        {/* Stats grid — matches HTML col-6 col-md-4 col-lg-3 grid */}
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
                                            {/* Status & Audience span full 2 cols each in original: replicate with 3-col grid */}
                                            {statCards.slice(0, 3).map(card => (
                                                <div key={card.label} className="text-center px-2 py-3 shadow rounded bg-white dark:bg-[#1a1f24]">
                                                    <div className="text-[11px] text-gray-400 mb-1">{card.label}</div>
                                                    <div className={`text-[16px] font-bold ${card.cls}`}>{card.value}</div>
                                                </div>
                                            ))}
                                        </div>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginTop: 10 }}>
                                            {statCards.slice(3).map(card => (
                                                <div key={card.label} className="text-center px-2 py-3 shadow rounded bg-white dark:bg-[#1a1f24]">
                                                    <div className="text-[11px] text-gray-400 mb-1">{card.label}</div>
                                                    <div className={`text-[15px] font-bold ${card.cls}`}>{card.value}</div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Pie Chart */}
                                        <div style={{ marginTop: 16, width: '100%', height: 300, display: 'flex', justifyContent: 'center' }}>
                                            {pieData.length > 0 ? (
                                                <ResponsiveContainer width={400} height={300}>
                                                    <PieChart>
                                                        <Pie
                                                            data={pieData}
                                                            cx="50%" cy="50%"
                                                            outerRadius={110}
                                                            dataKey="value"
                                                        >
                                                            {pieData.map((_, idx) => (
                                                                <Cell key={idx} fill={PIE_COLORS[idx % PIE_COLORS.length]} stroke={PIE_COLORS[idx % PIE_COLORS.length]} />
                                                            ))}
                                                        </Pie>
                                                        <Tooltip formatter={(val, name) => [val, name]} />
                                                        <Legend wrapperStyle={{ fontSize: 11 }} />
                                                    </PieChart>
                                                </ResponsiveContainer>
                                            ) : (
                                                <div style={{ display: 'flex', alignItems: 'center', color: '#999', fontSize: 13 }}>
                                                    No data available for chart
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* ── RIGHT: WhatsApp Template Preview ── */}
                                    <div>
                                        <WhatsAppPreview campaign={campaign} />
                                    </div>

                                </div>
                            </div>
                        )}

                        {/* ══ OTHER TABS (status-filtered grid + pie chart) ══ */}
                        {activeTab !== 'OverView' && (
                            <div className="p-3">
                                <StatusTabContent
                                    messages={messages}
                                    status={activeTab}
                                    costMap={costMap}
                                />
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

// ── Main CampaignReport ───────────────────────────────────────────────────────
function CampaignReport() {
    const [showfilter, setshowfilter]     = useState(false);
    const [CampaignName, setCampaignName] = useState('');
    const [TemplateName, setTemplateName] = useState('');
    const [TemplateType, setTemplateType] = useState('');
    const [InterfaceFilter, setInterfaceFilter] = useState('');
    const [IsScheduled, setIsScheduled]   = useState('');

    const [allData, setAllData]     = useState([]);
    const [filtered, setFiltered]   = useState([]);
    const [loading, setLoading]     = useState(false);
    const [error, setError]         = useState('');
    const [costMap, setCostMap]     = useState({});
    const [deliveryModal, setDeliveryModal] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage, setUsersPerPage] = useState(10);

    const { userId: clientId } = getUserIdFromToken();

    // Keep page in bounds
    React.useEffect(() => {
        const total = Math.ceil(filtered.length / usersPerPage) || 1;
        if (currentPage > total) setCurrentPage(total);
        if (currentPage < 1) setCurrentPage(1);
    }, [filtered, currentPage, usersPerPage]);

    const indexoflastuser  = currentPage * usersPerPage;
    const indexoffirstuser = indexoflastuser - usersPerPage;
    const pageData   = filtered.slice(indexoffirstuser, indexoflastuser);
    const totalpages = Math.ceil(filtered.length / usersPerPage) || 1;

    // ── Fetch ────────────────────────────────────────────────────────────────
    const fetchData = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            const res  = await fetch(`${API_URL}/auth/campaign/report`, { credentials: 'include' });
            const json = await res.json();
            if (!json.success) throw new Error('Failed');
            setAllData(json.data || []);
            setFiltered(json.data || []);
            setCurrentPage(1);

            if (clientId) {
                fetch(`${API_URL}/auth/campaigns/cost-summary?client_id=${clientId}`, { credentials: 'include' })
                    .then(r => r.json())
                    .then(costJson => {
                        const map = {};
                        (costJson.data || []).forEach(r => {
                            map[r.campaign_id] = {
                                total_cost:      Number(r.total_cost)      || 0,
                                net_cost:        Number(r.net_cost)        || 0,
                                total_refunded:  Number(r.total_refunded)  || 0,
                            };
                        });
                        setCostMap(map);
                    })
                    .catch(() => {});
            }
        } catch (e) {
            setError('Failed to load campaign data.');
        } finally {
            setLoading(false);
        }
    }, [clientId]);

    useEffect(() => { fetchData(); }, [fetchData]);

    // ── Filter ───────────────────────────────────────────────────────────────
    const applyFilter = () => {
        let d = [...allData];
        if (CampaignName) d = d.filter(r => (r.campaign_name || '').toLowerCase().includes(CampaignName.toLowerCase()));
        if (TemplateName) d = d.filter(r => (r.template_name || '').toLowerCase().includes(TemplateName.toLowerCase()));
        if (TemplateType) d = d.filter(r => r.template_type === TemplateType);
        if (InterfaceFilter) d = d.filter(r => (r.interface || '').toLowerCase() === InterfaceFilter.toLowerCase());
        if (IsScheduled !== '') d = d.filter(r => String(r.is_scheduled) === IsScheduled);
        setFiltered(d);
        setCurrentPage(1);
    };

    const clearFilter = () => {
        setCampaignName(''); setTemplateName(''); setTemplateType('');
        setInterfaceFilter(''); setIsScheduled('');
        setFiltered(allData); setCurrentPage(1);
    };

    // ── Per-row CSV download ──────────────────────────────────────────────────
    const handleDownloadRow = async (row) => {
        try {
            const res  = await fetch(`${API_URL}/auth/campaign/${row.id}`, { credentials: 'include' });
            const json = await res.json();
            const msgs = json.data || [];

            const headers = ['#', 'Campaign Name', 'Template', 'Phone Number', 'Variables', 'Status', 'Sent At'];
            const rows = msgs.map((m, i) => {
                let vars = '-';
                try { vars = JSON.parse(m.variables || '[]').join(', ') || '-'; } catch {}
                return [
                    i + 1,
                    row.campaign_name || '-',
                    row.template_name || '-',
                    m.phone_number || '-',
                    vars,
                    m.status || '-',
                    m.created_at ? new Date(m.created_at).toLocaleString() : '-'
                ];
            });
            const csv = [headers, ...rows].map(r => r.map(v => `"${v ?? ''}"`).join(',')).join('\n');
            const a   = document.createElement('a');
            a.href    = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
            a.download = `campaign_${row.id}_${row.campaign_name || 'report'}.csv`;
            a.click();
        } catch (e) {
            console.error('Download failed', e);
        }
    };

    // ── Global CSV download ───────────────────────────────────────────────────
    const handleDownload = () => {
        const headers = ['ID', 'Campaign Date', 'Campaign Name', 'Type', 'Template Name', 'Template Type', 'Interface', 'Is Scheduled', 'Total Count', 'Cost', 'Status'];
        const rows = filtered.map(r => {
            const c = costMap[r.id] || {};
            return [
                r.id,
                r.created_at ? new Date(r.created_at).toLocaleString() : '',
                r.campaign_name,
                r.campaign_type || '-',
                r.template_name,
                r.template_type,
                r.interface,
                r.is_scheduled ? 'Yes' : 'No',
                r.total_count,
                (c.total_cost || 0).toFixed(4),
                r.status,
            ];
        });
        const csv = [headers, ...rows].map(row => row.map(v => `"${v ?? ''}"`).join(',')).join('\n');
        const a   = document.createElement('a');
        a.href    = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
        a.download = 'campaign_report.csv'; a.click();
    };

    const grandTotal    = filtered.reduce((s, r) => s + (costMap[r.id]?.total_cost     || 0), 0);
    const grandRefunded = filtered.reduce((s, r) => s + (costMap[r.id]?.total_refunded || 0), 0);
    const grandNet      = filtered.reduce((s, r) => s + (costMap[r.id]?.net_cost       || 0), 0);

    // Columns matching the HTML layout
    const columns = [
        '#',
        'Campaign Date',
        'Campaign Info',
        'Template Info',
        'Interface / Channel',
        'Scheduled Info',
        'Is Journey',
        'Cost',
        'Total Count',
        'Action',
    ];

    return (
        <>
            {/* Delivery Report Full-screen Modal */}
            {deliveryModal && (
                <DeliveryReportModal
                    campaign={deliveryModal}
                    onClose={() => setDeliveryModal(null)}
                />
            )}

            {/* Summary Cards */}
            {!loading && allData.length > 0 && (
                <div className='grid grid-cols-3 gap-2 mb-3'>
                    {[
                        { label: 'Total Spent',    value: `₹${grandTotal.toFixed(4)}`,    color: 'text-red-500' },
                        { label: 'Total Refunded', value: `₹${grandRefunded.toFixed(4)}`, color: 'text-green-600' },
                        { label: 'Net Cost',       value: `₹${grandNet.toFixed(4)}`,      color: 'text-[#3f7fca]' },
                    ].map(card => (
                        <div key={card.label} className='border border-[#dee2e6] rounded-lg px-3 py-2 dark:border-[#2a3040]'>
                            <p className='text-[10px] text-gray-400'>{card.label}</p>
                            <p className={`text-[13px] font-bold ${card.color}`}>{card.value}</p>
                        </div>
                    ))}
                </div>
            )}

            {/* Actions row */}
            <div className='w-full flex items-center justify-between mb-2'>
                <p className='text-[12px] text-gray-500 dark:text-gray-400'>
                    Total: <span className='font-bold text-[#37715d]'>{allData.length}</span> campaigns
                </p>
                <div className='flex gap-2'>
                    <button
                        onClick={fetchData}
                        className='flex items-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-1 hover:bg-[#37715d] hover:text-white transition-colors'
                    >
                        <TbReload className='text-[13px]' /><span className='text-[12px] font-bold'>Refresh</span>
                    </button>
                    <button
                        onClick={handleDownload}
                        className='flex items-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-1 hover:bg-[#3f7fca] hover:text-white transition-colors'
                    >
                        <FaDownload className='text-[12px]' /><span className='text-[12px] font-bold'>Download</span>
                    </button>
                </div>
            </div>

            {/* Filter accordion */}
            <div
                onClick={() => setshowfilter(!showfilter)}
                className='w-full flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] cursor-pointer'
            >
                <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-white'>
                    <RiCollapseDiagonalLine /> Filter Records
                </div>
                <div className='flex items-center text-[#576071] dark:text-white'>
                    {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                </div>
            </div>

            {showfilter && (
                <div className='bg-[#edf1f5] py-2 px-4 w-full dark:bg-[#121519]'>
                    <div className='w-full flex flex-wrap gap-2'>
                        {/* Campaign Name */}
                        <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Campaign Name</label>
                            <input
                                value={CampaignName} onChange={e => setCampaignName(e.target.value)}
                                type="text" placeholder="Search campaign..."
                                className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
                            />
                        </div>
                        {/* Template Name */}
                        <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Template Name</label>
                            <input
                                value={TemplateName} onChange={e => setTemplateName(e.target.value)}
                                type="text" placeholder="Search template..."
                                className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
                            />
                        </div>
                        {/* Template Type */}
                        <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Template Type</label>
                            <select
                                value={TemplateType} onChange={e => setTemplateType(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
                            >
                                <option value="">All Types</option>
                                <option value="utility">Utility</option>
                                <option value="authentication">Authentication</option>
                                <option value="marketing">Marketing</option>
                            </select>
                        </div>
                        {/* Interface */}
                        <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Interface</label>
                            <select
                                value={InterfaceFilter} onChange={e => setInterfaceFilter(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
                            >
                                <option value="">All Interfaces</option>
                                <option value="web">Web</option>
                                <option value="http">Http</option>
                                <option value="excel">Excel</option>
                                <option value="scheduler">Scheduler</option>
                                <option value="otp">OTP</option>
                                <option value="android">Android</option>
                            </select>
                        </div>
                        {/* Is Scheduled */}
                        <div className='w-full sm:w-[48%] lg:w-[23%] flex flex-col gap-1'>
                            <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Is Scheduled</label>
                            <select
                                value={IsScheduled} onChange={e => setIsScheduled(e.target.value)}
                                className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
                            >
                                <option value="">All</option>
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select>
                        </div>
                        {/* Buttons */}
                        <div className='w-full sm:w-[48%] lg:w-[19%] flex items-center gap-1 mt-4'>
                            <button
                                onClick={applyFilter}
                                className='flex items-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-white transition-colors'
                            >
                                <FaFilter /><span className='text-[12px] font-bold'>Filter</span>
                            </button>
                            <button
                                onClick={clearFilter}
                                className='flex items-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-white transition-colors'
                            >
                                <TbReload /><span className='text-[12px] font-bold'>Clear</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {error && (
                <div className='w-full bg-red-50 border border-red-200 text-red-600 text-[12px] px-4 py-2 rounded-md mb-2'>{error}</div>
            )}

            {/* ── TABLE ───────────────────────────────────────────────────── */}
            <div className='overflow-x-auto'>
                <table className="w-full border-collapse border border-[#dee2e6]">
                    <thead>
                        <tr className="text-left">
                            {columns.map(col => (
                                <th key={col} className="p-1 border border-[#dee2e6] bg-[#f6f9fc] dark:bg-[#1a1f24]">
                                    <div className="flex justify-between items-center gap-1">
                                        <span className='text-[11px] text-[#576071] dark:text-white font-semibold whitespace-nowrap'>{col}</span>
                                        {!['Action', '#', 'Scheduled Info', 'Is Journey', 'Cost'].includes(col) && (
                                            <button type="button" className="text-gray-400 hover:text-black flex-shrink-0">
                                                <TbArrowsSort className="text-[11px]" />
                                            </button>
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={columns.length} className="py-8 text-center">
                                    <div className="flex items-center justify-center gap-2 text-[12px] text-gray-400">
                                        <div className="w-4 h-4 border-2 border-[#37715d] border-t-transparent rounded-full animate-spin" />
                                        Loading campaigns...
                                    </div>
                                </td>
                            </tr>
                        ) : pageData.length === 0 ? (
                            <tr>
                                <td colSpan={columns.length} className="py-8 text-center text-[12px] text-gray-400">
                                    No campaigns found
                                </td>
                            </tr>
                        ) : pageData.map((row, i) => {
                            const cost = costMap[row.id] || { total_cost: 0, net_cost: 0, total_refunded: 0 };
                            const createdAt = row.created_at ? new Date(row.created_at) : null;

                            // Format like "Sat, May 09, 2026 02:38 PM"
                            const dateStr = createdAt
                                ? createdAt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: '2-digit', year: 'numeric' })
                                  + ' ' + createdAt.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
                                : '-';

                            return (
                                <tr
                                    key={row.id || i}
                                    className="odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#e8f0fa] dark:hover:bg-[#2a2f35] transition-colors align-top"
                                >
                                    {/* # */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6] text-gray-400 dark:text-gray-400 whitespace-nowrap">
                                        {indexoffirstuser + i + 1}
                                    </td>

                                    {/* Campaign Date */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white text-gray-600 whitespace-nowrap">
                                        {dateStr}
                                    </td>

                                    {/* Campaign Info */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6]">
                                        <div className="dark:text-white">
                                            <span className="font-semibold text-gray-600 dark:text-gray-300">Name: </span>
                                            <span className="font-semibold text-[#3f7fca]">
                                                {row.campaign_name || 'Untitled Campaign'}
                                            </span>
                                        </div>
                                        <div className="mt-0.5">
                                            <span className="font-semibold text-gray-600 dark:text-gray-300">Type: </span>
                                            <span className="text-gray-500 dark:text-gray-400 capitalize">
                                                {row.campaign_type || row.type || 'Normal'}
                                            </span>
                                        </div>
                                        
                                    </td>

                                    {/* Template Info */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6]">
                                        <div>
                                            <span className="font-semibold text-gray-600 dark:text-gray-300">Name: </span>
                                            <span className="dark:text-white">{row.template_name || '-'}</span>
                                        </div>
                                        <div className="mt-0.5">
                                            <span className="font-semibold text-gray-600 dark:text-gray-300">Type: </span>
                                            <span className="dark:text-white capitalize">{row.template_type || '-'}</span>
                                        </div>
                                    </td>

                                    {/* Interface / Channel */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6]">
                                        <div>
                                            <span className="font-semibold text-gray-600 dark:text-gray-300">Interface: </span>
                                            <span className="dark:text-white capitalize">{row.interface || 'Web'}</span>
                                        </div>
                                        <div className="mt-0.5">
                                            <span className="font-semibold text-gray-600 dark:text-gray-300">Channel: </span>
                                            <span className="dark:text-white font-mono">{row.channel || row.phone_number || '-'}</span>
                                        </div>
                                    </td>

                                    {/* Scheduled Info */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6]">
                                        <div>
                                            <span className="font-semibold text-gray-600 dark:text-gray-300">IsScheduled: </span>
                                            <span className="dark:text-white">{row.is_scheduled ? 'Yes' : 'No'}</span>
                                        </div>
                                        <div className="mt-0.5">
                                            <span className="font-semibold text-gray-600 dark:text-gray-300">ScheduleDate: </span>
                                            <span className="dark:text-white">
                                                {row.schedule_date ? new Date(row.schedule_date).toLocaleString() : 'N/A'}
                                            </span>
                                        </div>
                                    </td>

                                    {/* Is Journey */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white text-center">
                                        {row.is_journey ? 'Yes' : 'No'}
                                    </td>

                                    {/* Cost */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6] whitespace-nowrap">
                                        <span className="text-[#3f7fca] font-semibold">
                                            {cost.total_cost.toFixed(4)}
                                        </span>
                                    </td>

                                    {/* Total Count */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white text-center font-semibold">
                                        {row.total_count ?? '-'}
                                    </td>

                                    {/* Action */}
                                    <td className="p-1 text-[11px] border border-[#dee2e6]">
                                        <div className="flex items-center gap-1 whitespace-nowrap">
                                            {/* View Details */}
                                            <button
                                                onClick={() => setDeliveryModal(row)}
                                                className="flex items-center gap-1 border border-[#17a2b8] text-[#17a2b8] hover:bg-[#17a2b8] hover:text-white rounded px-1.5 py-0.5 text-[10px] font-semibold transition-colors"
                                                title="View Details"
                                            >
                                                <FaList className="text-[9px]" />
                                            </button>
                                            {/* Delivery Report */}
                                            <button
                                                onClick={() => setDeliveryModal(row)}
                                                className="flex items-center gap-1 border border-[#3f7fca] text-[#3f7fca] hover:bg-[#3f7fca] hover:text-white rounded px-1.5 py-0.5 text-[10px] font-semibold transition-colors"
                                                title="Delivery Report"
                                            >
                                                <FaEye className="text-[9px]" />
                                            </button>
                                            {/* Hamburger dropdown */}
                                            <RowActionMenu
                                                row={row}
                                                onViewDelivery={(r) => setDeliveryModal(r)}
                                                onDownloadRow={handleDownloadRow}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className='flex flex-col md:flex-row md:items-center md:justify-between w-full mt-2 gap-2'>
                <div className="flex items-center gap-1">
                    <span className="text-[11px] text-[#576071] dark:text-[#ccc]">Show</span>
                    <select
                        className="text-[11px] px-1 py-0.5 rounded border border-gray-300 bg-white dark:bg-[#191d22] dark:text-white"
                        value={usersPerPage}
                        onChange={e => { setUsersPerPage(Number(e.target.value)); setCurrentPage(1); }}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                    <span className="text-[11px] text-[#576071] dark:text-[#ccc]">entries</span>
                </div>
                <p className='text-[11px] text-[#3f7fc8]'>
                    Showing {filtered.length === 0 ? 0 : indexoffirstuser + 1} to {Math.min(indexoflastuser, filtered.length)} of {filtered.length} records
                </p>
                <div className="flex items-center space-x-2">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                        className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                    >Prev</button>
                    <p className='text-[11px] text-[#3f7fc8]'>{currentPage} of {totalpages} pages</p>
                    <button
                        disabled={currentPage >= totalpages}
                        onClick={() => setCurrentPage(p => Math.min(totalpages, p + 1))}
                        className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                    >Next</button>
                </div>
            </div>
        </>
    );
}

export default CampaignReport;